export const addFilesToZip = (zip, reportDefinition) => {
  if (reportDefinition.name !== 'Detailed Appraisal Report') {
    zip.file(reportDefinition.filename + '.csv', reportDefinition.reportData);
    return;
  }

  reportDefinition.reportData.forEach(element => {
    zip.file(reportDefinition.filename + '-' + element.fileIdenfitifier + '.csv', element['Data']);
  });
};
